module.exports = __webpack_public_path__ + "img/background3.b3db1ece.jpeg";